import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "../services/validations/resolvers/joiResolver";
import schema from "../services/validations/reviewSchema";
import { useRecaptcha } from "../services/hooks/useRecaptcha";
import { enableCollapse } from "../public/js/core";
import Rating from "./Rating";
import Notice from "./Notice";

const ProductReviewForm = React.forwardRef(
  ({ onReview, isPostingReview }, ref) => {
    const [productRating, setProductRating] = useState(0);

    const [productRatingError, setProductRatingError] = useState();

    const [reviewData, setReviewData] = useState();

    const { handleSubmit, register, errors } = useForm({
      mode: "onBlur",
      reValidateMode: "onBlur",
      resolver: joiResolver(schema),
    });

    const { executeRecaptcha, isSafeRequest, recaptchaStatus } = useRecaptcha();

    const [isSubmittingForm, setIsSubmittingForm] = useState(false);

    const onSubmit = (data) => {
      if (!productRating) {
        //show error
        setProductRatingError("Please provide a rating.");
        return;
      }

      setProductRatingError();

      executeRecaptcha("product_review_request");

      setReviewData({
        ...data,
        rating: productRating,
      });
    };

    const submitReview = (data) => {
      onReview(data);
    };

    const handleProductRatingErrorDismiss = () => {
      setProductRatingError();
    };

    useEffect(() => {
      enableCollapse();
    }, []);

    useEffect(() => {
      if (recaptchaStatus === "ready" && isSafeRequest && reviewData) {
        submitReview(reviewData);
      }
    }, [recaptchaStatus]);

    useEffect(() => {
      setIsSubmittingForm(isPostingReview || recaptchaStatus === "pending");
    }, [recaptchaStatus, isPostingReview]);

    return (
      <form ref={ref} onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="row">
          <div className="col-12 mb-6 text-center">
            {/* Text */}
            <p className="mb-1 font-size-xs">Rating:</p>

            <Rating
              rating={productRating}
              isRatable
              size="h5"
              onRatingChange={setProductRating}
              tooltip
            />

            {productRatingError && (
              <Notice
                message={productRatingError}
                type="danger"
                onDismiss={handleProductRatingErrorDismiss}
              />
            )}
          </div>
          <div className="col-12">
            {/* Name */}
            <div className="form-group">
              <label className="sr-only" htmlFor="title">
                Review Title:
              </label>
              <input
                ref={register}
                className="form-control form-control-sm"
                type="text"
                name="title"
                placeholder="Review Title"
              />
              {errors.title && (
                <span className="input-error">
                  Please enter a title e.g. Best Foundation Ever!
                </span>
              )}
            </div>
          </div>
          <div className="col-12">
            {/* Name */}
            <div className="form-group">
              <label className="sr-only" htmlFor="text">
                Review:
              </label>
              <textarea
                ref={register}
                className="form-control form-control-sm"
                rows={5}
                name="content"
                placeholder="Review"
              />
              {errors.content && (
                <span className="input-error">Please enter your review</span>
              )}
            </div>
          </div>
          <div className="col-12 text-center">
            {/* Button */}
            <button
              className="btn btn-outline-dark"
              type="submit"
              disabled={isSubmittingForm}
            >
              {isSubmittingForm ? "Please wait..." : "Post review"}
            </button>
          </div>
        </div>
      </form>
    );
  }
);

export default ProductReviewForm;
